import React from 'react';
import { integrateLocalization } from 'shared/app/localization';

integrateLocalization().catch(e => console.error(e));

export const I18nInitializer: React.FC<React.PropsWithChildren> = props => {
  return <React.Fragment>{props.children}</React.Fragment>;
};
